import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ITEM_TITLE: `${cleanedFilename(__filename)}-item-title`,
  ITEM_CLICK_HANDLER: `${cleanedFilename(__filename)}-item-click-handler`,
  ITEM_SHOW_MORE: `${cleanedFilename(__filename)}-item-show-more`,
};
